
import "@sparta.wealth-shared.modules/single-page-orchestration-module/dist/styles.css"
import "@sparta.my-merrill-login.modules/semantic-markup-runtime-module/dist/styles.css"


import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es6.js"

import "@sparta.wealth-shared.modules/single-page-orchestration-module/dist/es6.js"
import "@sparta.my-merrill-login.modules/semantic-markup-runtime-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.sales.modules/eyebrow-banner-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-es6" */ "@sparta.sales.modules/eyebrow-banner-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-styles" */ "@sparta.sales.modules/eyebrow-banner-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.authhelper.modules/ah-widget-loader-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/authhelper-ah-widget-loader-module-es6" */ "@sparta.authhelper.modules/ah-widget-loader-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/authhelper-ah-widget-loader-module-styles" */ "@sparta.authhelper.modules/ah-widget-loader-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/merrill-hero-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-merrill-hero-module-es6" */ "@sparta.merrill-homepage.modules/merrill-hero-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-merrill-hero-module-styles" */ "@sparta.merrill-homepage.modules/merrill-hero-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/cta-tile-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-cta-tile-module-es6" */ "@sparta.merrill-homepage.modules/cta-tile-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-cta-tile-module-styles" */ "@sparta.merrill-homepage.modules/cta-tile-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/preferred-rewards-callout-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-preferred-rewards-callout-module-es6" */ "@sparta.merrill-homepage.modules/preferred-rewards-callout-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-preferred-rewards-callout-module-styles" */ "@sparta.merrill-homepage.modules/preferred-rewards-callout-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/carousel-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-carousel-module-es6" */ "@sparta.merrill-homepage.modules/carousel-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-carousel-module-styles" */ "@sparta.merrill-homepage.modules/carousel-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/contact-helper-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-contact-helper-module-es6" */ "@sparta.merrill-homepage.modules/contact-helper-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-contact-helper-module-styles" */ "@sparta.merrill-homepage.modules/contact-helper-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/merrill-modal-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-merrill-modal-module-es6" */ "@sparta.merrill-homepage.modules/merrill-modal-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-merrill-modal-module-styles" */ "@sparta.merrill-homepage.modules/merrill-modal-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global-gt.modules/global-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/global-gt-global-footer-module-es6" */ "@sparta.global-gt.modules/global-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/global-gt-global-footer-module-styles" */ "@sparta.global-gt.modules/global-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/eyebrow-banner-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-es6" */ "@sparta.sales.modules/eyebrow-banner-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-styles" */ "@sparta.sales.modules/eyebrow-banner-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/sticky-nav-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-sticky-nav-module-es6" */ "@sparta.merrill-homepage.modules/sticky-nav-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-sticky-nav-module-styles" */ "@sparta.merrill-homepage.modules/sticky-nav-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrill-homepage.modules/sticky-nav-legacy-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-sticky-nav-legacy-module-es6" */ "@sparta.merrill-homepage.modules/sticky-nav-legacy-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrill-homepage-sticky-nav-legacy-module-styles" */ "@sparta.merrill-homepage.modules/sticky-nav-legacy-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  jcrs: [
    {
      name: "site/merrill-homepage/module-specific/sticky-nav-module/en/sticky-nav-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-sticky-nav-module-en-sticky-nav-module.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-sticky-nav-module-en-sticky-nav-module-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/sticky-nav-module/en/sticky-nav-module-wcag22.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-sticky-nav-module-en-sticky-nav-module-wcag22.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-sticky-nav-module-en-sticky-nav-module-wcag22-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/merrill-hero-module/en/merrill-homepage.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-merrill-hero-module-en-merrill-homepage.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-merrill-hero-module-en-merrill-homepage-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/cta-tile-module/en/cta-tile-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-cta-tile-module-en-cta-tile-module.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-cta-tile-module-en-cta-tile-module-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/preferred-rewards-callout-module/en/preferred-rewards-callout-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-preferred-rewards-callout-module-en-preferred-rewards-callout-module.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-preferred-rewards-callout-module-en-preferred-rewards-callout-module-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/carousel-module/en/carousel-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-carousel-module-en-carousel-module.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-carousel-module-en-carousel-module-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/module-specific/contact-helper-module/en/contact-helper-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-module-specific-contact-helper-module-en-contact-helper-module.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-module-specific-contact-helper-module-en-contact-helper-module-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/shared/footer/en/broker-check.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-shared-footer-en-broker-check.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-shared-footer-en-broker-check-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/shared/footer/en/merrill.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-shared-footer-en-merrill.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-shared-footer-en-merrill-en-T1747491350831.json" )}
    },
    {
      name: "site/merrill-homepage/shared/footer/en/merrill.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrill-homepage-shared-footer-en-merrill.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrill-homepage-shared-footer-en-merrill-en-T1747491350831.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/eyebrow-banner/eyebrow-banner.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-eyebrow-banner-eyebrow-banner.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/591A7EFF/build/prod1/site/merrill/spa-assets/data/site-merrilledge-homepage-module-specific-v2-eyebrow-banner-eyebrow-banner-en-T1747491350831.json" )}
    }
  ]
}


// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
